/* eslint-disable react-hooks/rules-of-hooks */
import {
  ITypeIIsClientSpecificRoleDataType,
  useRole,
} from "../../../Context/RoleContext";
import {
  Master_Type,
  Report_Type,
  Report_TypeAction,
  Setting_Type,
} from "../../Services/UsersService";
import { IPermissionActionType } from "./UserPermissionCommonData";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import { SettingsSections } from "../../Services/SettingService";

// User Repost Security
export const findUserReportAccessSecurity = (
  allUserData: any,
  componentType: Report_Type,
  action: Report_TypeAction
) => {
  let isPremission = false;
  const findType = allUserData?.reportsAccessList?.find(
    (x: any) => x.reportName === componentType
  );
  // console.log("data 2222 99999999911", findType);
  switch (componentType) {
    case Report_Type.PnL:
      isPremission = findUserReportAction(findType, action);
      break;
    case Report_Type.BalanceSheet:
      isPremission = findUserReportAction(findType, action);
      break;
    case Report_Type.TrialBalance:
      isPremission = findUserReportAction(findType, action);
      break;
    case Report_Type.CashFlow:
      isPremission = findUserReportAction(findType, action);
      break;
    case Report_Type.DebtorsAgeing:
      isPremission = findUserReportAction(findType, action);
      break;
    case Report_Type.CreditorsAgeing:
      isPremission = findUserReportAction(findType, action);
      break;
    case Report_Type.CustomerOutstanding:
      isPremission = findUserReportAction(findType, action);
      break;
    case Report_Type.SupplierOutstanding:
      isPremission = findUserReportAction(findType, action);
      break;
    case Report_Type.GeneralLedger:
      isPremission = findUserReportAction(findType, action);
      break;
    case Report_Type.FAR:
      isPremission = findUserReportAction(findType, action);
      break;
    case Report_Type.BRS:
      isPremission = findUserReportAction(findType, action);
      break;
    case Report_Type.GST:
      isPremission = findUserReportAction(findType, action);
      break;
    case Report_Type.TCSTDS:
      isPremission = findUserReportAction(findType, action);
      break;
  }
  return isPremission;
};

export const findUserReportAction = (
  findType: any,
  actionType: Report_TypeAction
) => {
  let type = false;
  // console.log(
  //   "data 2222 9999999999",
  //   findType?.allowToView,
  //   findType?.allowToPrint
  // );
  switch (actionType) {
    case Report_TypeAction.allowToView:
      type = findType?.allowToView;
      break;
    case Report_TypeAction.allowToPrint:
      type = findType?.allowToPrint;
      break;
  }
  return type;
};

// User Setting Security
export const findUserSettingAccessSecurity = (
  allUserData: any,
  componentType: Setting_Type
  // action: Report_TypeAction
) => {
  let isPremission = false;
  const findType = allUserData?.settingsAccessList?.find(
    (x: any) => x.settingType === componentType
  );
  console.log(
    // "data 2222 findUserSettingAccessSecurity",
    // allUserData,
    // componentType,
    findType
  );
  if (findType) {
    switch (componentType) {
      case Setting_Type.CompanyInfo:
        isPremission = findType?.allowToEdit;
        break;
      case Setting_Type.Voucher:
        isPremission = findType?.allowToEdit;
        break;
      case Setting_Type.Report:
        isPremission = findType?.allowToEdit;
        break;
      case Setting_Type.OpeningEntry:
        isPremission = findType?.allowToEdit;
        break;
      case Setting_Type.Templates:
        isPremission = findType?.allowToEdit;
        break;
      case Setting_Type.DefaultLedger:
        isPremission = findType?.allowToEdit;
        break;
      case Setting_Type.TnC:
        isPremission = findType?.allowToEdit;
        break;
      case Setting_Type.Email:
        isPremission = findType?.allowToEdit;
        break;
      // case Setting_Type.Items:
      //   isPremission = findType.allowToEdit;
      //   break;
      // case Setting_Type.TDS:
      //   isPremission = findType.allowToEdit;
      //   break;
      // case Setting_Type.TCS:
      //   isPremission = findType.allowToEdit;
      //   break;
      // case Setting_Type.Currencies:
      //   isPremission = findType.allowToEdit;
      //   break;
    }
  }
  return isPremission;
};

// User Setting Route
export const findUserSettingFirstRoute = (allUserData: any) => {
  // let isPremission = false;
  const findType = allUserData?.settingsAccessList?.find(
    (x: any) => x.settingType.allowToEdit === true
  );
  return findType;
};

// User Master Security
export const findUserMasterAccessSecurity = (
  allUserData: any,
  componentType: Master_Type
  // action: Report_TypeAction
) => {
  let isPremission = false;
  const findType = allUserData.settingsAccessList?.find(
    (x: any) => x.settingType === componentType
  );
  // console.log(
  //   "data 2222 findUserSettingAccessSecurity",
  // allUserData,
  //   // componentType,
  //   findType
  // );
  switch (componentType) {
    case Master_Type.Client:
      isPremission = findType.allowToEdit;
      break;
    case Master_Type.Ledger:
      isPremission = findType.allowToEdit;
      break;
    case Master_Type.Group:
      isPremission = findType.allowToEdit;
      break;
    case Master_Type.Item:
      isPremission = findType.allowToEdit;
      break;
    case Master_Type.ItemGroup:
      isPremission = findType.allowToEdit;
      break;
    case Master_Type.Unit:
      isPremission = findType.allowToEdit;
      break;
    case Master_Type.Asset:
      isPremission = findType.allowToEdit;
      break;
      //case Master_Type.Email:
      isPremission = findType.allowToEdit;
      break;
  }
  return isPremission;
};

export const findUserActon = (findType: any, actionType: string) => {
  let type = false;
  // console.log("data 2222 9999999999", findType?.actions?.authorize);
  switch (actionType) {
    case "authorize":
      type = findType?.actions?.authorize;
      break;
    case "addOrEdit":
      type = findType?.actions?.addOrEdit;
      break;
    case "delete":
      type = findType?.actions?.delete;
      break;
    case "print":
      type = findType?.actions?.print;
      break;
  }
  return type;
};

// findPremissionIsCompanyRole;

export const findPremissionIsCompanyRole = (actions: string[]) => {
  const { getRole } = useRole();
  let exists = false;
  const localData = getRole();
  // console.log("localData 11", localData);

  exists = localData[0]?.accessSettings?.some((v: any) => actions?.includes(v));
  // }
  return exists;
};

export const findPremissionIsCLientRole = (
  actions: string[],
  clientId: string
) => {
  const { getRole } = useRole();
  let exists = false;
  const localData = getRole();
  console.log("localData findPremissionIsCLientRole", localData, clientId);

  exists =
    localData?.length > 0
      ? localData
          ?.find((x) => x?.clientIdList[0] === clientId)
          ?.accessSettings.some((v: any) => actions?.includes(v))!
      : false;
  return exists;
};

export const findUserPremission = (
  actions: string[],
  isClientSpecificRole?: boolean,
  clientId?: string,
  settingType?: SettingsSections[],
  type?: {
    actionType: IPermissionActionType;
    dataType: ITypeIIsClientSpecificRoleDataType[];
  }
) => {
  const { getRole } = useRole();
  let exists = false;
  const localData = getRole();
  // console.log("localData 22", isClientSpecificRole, localData);
  if (isClientSpecificRole) {
    // const localData: IRole[] = Utils.getLocal("RoleList");
    const clientData = localData?.find((x) => x.clientIdList[0] === clientId);

    const isClientSpecificRoleVouchersData =
      clientData?.isClientSpecificRoleVouchersData;

    if (
      isClientSpecificRoleVouchersData?.length! > 0 &&
      settingType?.length! > 0 &&
      settingType?.length &&
      type?.dataType?.length! > 0
    ) {
      // console.log("SettingType", SettingType);
      for (let dataType of type?.dataType!) {
        for (let sType of settingType) {
          const findSettingsSectionsData =
            dataType === ITypeIIsClientSpecificRoleDataType.Vouchers
              ? isClientSpecificRoleVouchersData?.find((x) => x?.type === sType)
                  ?.data.Vouchers
              : dataType === ITypeIIsClientSpecificRoleDataType.Setting
              ? isClientSpecificRoleVouchersData?.find((x) => x?.type === sType)
                  ?.data.Setting
              : isClientSpecificRoleVouchersData?.find((x) => x?.type === sType)
                  ?.data.TandC;

          // console.log("data 1111111", findSettingsSectionsData);

          switch (type?.actionType) {
            case IPermissionActionType.View:
              if (
                findSettingsSectionsData?.View?.length! > 0 &&
                findSettingsSectionsData?.View
              ) {
                actions.push(...findSettingsSectionsData?.View);
              }
              break;
            case IPermissionActionType.Add:
              if (
                findSettingsSectionsData?.View?.length! > 0 &&
                findSettingsSectionsData?.Add
              ) {
                actions.push(...findSettingsSectionsData?.Add);
              }
              break;
            case IPermissionActionType.Edit:
              if (
                findSettingsSectionsData?.Edit?.length! > 0 &&
                findSettingsSectionsData?.Edit
              ) {
                actions.push(...findSettingsSectionsData?.Edit);
              }
              break;
            case IPermissionActionType.Delete:
              if (
                findSettingsSectionsData?.Delete?.length! > 0 &&
                findSettingsSectionsData?.Delete
              ) {
                actions.push(...findSettingsSectionsData?.Delete);
              }
              break;
            case IPermissionActionType.Print:
              if (
                findSettingsSectionsData?.Print?.length! > 0 &&
                findSettingsSectionsData?.Print
              ) {
                actions.push(...findSettingsSectionsData?.Print);
              }
              break;
            case IPermissionActionType.Authorize:
              if (
                findSettingsSectionsData?.Authorize?.length! > 0 &&
                findSettingsSectionsData?.Authorize
              ) {
                actions.push(...findSettingsSectionsData?.Authorize);
              }
              break;

            default:
              break;
          }
        }
      }
    }

    // console.log("clientData", actions);

    exists = clientData?.accessSettings?.some((v: any) => actions?.includes(v))!;
  } else {
    // const localData: IRole[] = Utils.getLocal("RoleList");

    exists = localData[0]?.accessSettings?.some((v: any) =>
      actions?.includes(v)
    );
  }
  return exists;
};

export const findUserOnlyOnePremission = (
  actions: string,
  isClientSpecificRole?: boolean,
  clientId?: string
) => {
  // debugger;
  let exists = false;
  const { getRole } = useRole();
  const localData = getRole();
  // const { clientSpecificRole } = useUser();
  // console.log("local data findUserOnlyOnePremission");
  if (isClientSpecificRole) {
    // const localData: IRole[] = Utils.getLocal("RoleList");
    const findClientRole = localData?.find(
      (x: any) => x.clientIdList[0] === clientId
    );
    if (!findClientRole) {
      console.error("findClientRole not find");
      exists = false;
    } else {
      exists = findClientRole?.accessSettings?.find(
        (x: string) => x === actions
      )
        ? true
        : false;
    }
  } else {
    exists = localData[0]?.accessSettings?.find((x) => x === actions)
      ? true
      : false;
  }
  return exists;
};

// Ledger & Group Find
export const premissionLedgerAndGroup = (
  clientId: string,
  ledgerByGroupsType: SearchLedgerByGroupsTypes,
  actionTypeAll: IPermissionActionType,
  masterName: string,
  clientSpecificRole?: boolean
): boolean => {
  let permissionString: string | undefined;

  // console.log("local data premissionLedgerAndGroup");

  switch (ledgerByGroupsType) {
    case SearchLedgerByGroupsTypes.DirectExpenses:
    case SearchLedgerByGroupsTypes.IndirectExpenses:
    case SearchLedgerByGroupsTypes.DirectExpensesWithDutiesAndTaxes:
    case SearchLedgerByGroupsTypes.IndirectExpensesWithDutiesAndTaxes:
    case SearchLedgerByGroupsTypes.AllExpensesWithDutiesAndTaxes:
    case SearchLedgerByGroupsTypes.SellingAndDistributionExpenses:
    case SearchLedgerByGroupsTypes.AllExpenses:
      switch (actionTypeAll) {
        case IPermissionActionType.Add:
          permissionString = `Master.${masterName}.Expenses.Add`;
          break;
        case IPermissionActionType.Edit:
          permissionString = `Master.${masterName}.Expenses.Edit`;
          break;
        case IPermissionActionType.Delete:
          permissionString = `Master.${masterName}.Expenses.Delete`;
          break;
        case IPermissionActionType.Print:
          permissionString = `Master.${masterName}.Expenses.Print`;
          break;
        case IPermissionActionType.Authorize:
          permissionString = `Master.${masterName}.Expenses.Authorize`;
          break;
      }
      break;

    case SearchLedgerByGroupsTypes.IndirectIncomeOnly:
      switch (actionTypeAll) {
        case IPermissionActionType.Add:
          permissionString = `Master.${masterName}.Income.Add`;
          break;
        case IPermissionActionType.Edit:
          permissionString = `Master.${masterName}.Income.Edit`;
          break;
        case IPermissionActionType.Delete:
          permissionString = `Master.${masterName}.Income.Delete`;
          break;
        case IPermissionActionType.Print:
          permissionString = `Master.${masterName}.Income.Print`;
          break;
        case IPermissionActionType.Authorize:
          permissionString = `Master.${masterName}.Income.Authorize`;
          break;
      }
      break;

    case SearchLedgerByGroupsTypes.PartiesOnly:
      switch (actionTypeAll) {
        case IPermissionActionType.Add:
          permissionString = `Master.${masterName}.Party.Add`;
          break;
        case IPermissionActionType.Edit:
          permissionString = `Master.${masterName}.Party.Edit`;
          break;
        case IPermissionActionType.Delete:
          permissionString = `Master.${masterName}.Party.Delete`;
          break;
        case IPermissionActionType.Print:
          permissionString = `Master.${masterName}.Party.Print`;
          break;
        case IPermissionActionType.Authorize:
          permissionString = `Master.${masterName}.Party.Authorize`;
          break;
      }
      break;

    case SearchLedgerByGroupsTypes.All:
      switch (actionTypeAll) {
        case IPermissionActionType.Add:
          permissionString = `Master.${masterName}.Add`;
          break;
        case IPermissionActionType.Edit:
          permissionString = `Master.${masterName}.Edit`;
          break;
        case IPermissionActionType.Delete:
          permissionString = `Master.${masterName}.Delete`;
          break;
        case IPermissionActionType.Print:
          permissionString = `Master.${masterName}.Print`;
          break;
        case IPermissionActionType.Authorize:
          permissionString = `Master.${masterName}.Authorize`;
          break;
      }
      break;

    case SearchLedgerByGroupsTypes.DebtorsOnly:
      switch (actionTypeAll) {
        case IPermissionActionType.Add:
          permissionString = `Master.${masterName}.Customer.Add`;
          break;
        case IPermissionActionType.Edit:
          permissionString = `Master.${masterName}.Customer.Edit`;
          break;
        case IPermissionActionType.Delete:
          permissionString = `Master.${masterName}.Customer.Delete`;
          break;
        case IPermissionActionType.Print:
          permissionString = `Master.${masterName}.Customer.Print`;
          break;
        case IPermissionActionType.Authorize:
          permissionString = `Master.${masterName}.Customer.Authorize`;
          break;
      }
      break;

    case SearchLedgerByGroupsTypes.CreditorsOnly:
      switch (actionTypeAll) {
        case IPermissionActionType.Add:
          permissionString = `Master.${masterName}.Suppliers.Add`;
          break;
        case IPermissionActionType.Edit:
          permissionString = `Master.${masterName}.Suppliers.Edit`;
          break;
        case IPermissionActionType.Delete:
          permissionString = `Master.${masterName}.Suppliers.Delete`;
          break;
        case IPermissionActionType.Print:
          permissionString = `Master.${masterName}.Suppliers.Print`;
          break;
        case IPermissionActionType.Authorize:
          permissionString = `Master.${masterName}.Suppliers.Authorize`;
          break;
      }
      break;

    case SearchLedgerByGroupsTypes.Sales:
      switch (actionTypeAll) {
        case IPermissionActionType.Add:
          permissionString = `Master.${masterName}.Sales.Add`;
          break;
        case IPermissionActionType.Edit:
          permissionString = `Master.${masterName}.Sales.Edit`;
          break;
        case IPermissionActionType.Delete:
          permissionString = `Master.${masterName}.Sales.Delete`;
          break;
        case IPermissionActionType.Print:
          permissionString = `Master.${masterName}.Sales.Print`;
          break;
        case IPermissionActionType.Authorize:
          permissionString = `Master.${masterName}.Sales.Authorize`;
          break;
      }
      break;

    case SearchLedgerByGroupsTypes.Purchase:
      switch (actionTypeAll) {
        case IPermissionActionType.Add:
          permissionString = `Master.${masterName}.Purchase.Add`;
          break;
        case IPermissionActionType.Edit:
          permissionString = `Master.${masterName}.Purchase.Edit`;
          break;
        case IPermissionActionType.Delete:
          permissionString = `Master.${masterName}.Purchase.Delete`;
          break;
        case IPermissionActionType.Print:
          permissionString = `Master.${masterName}.Purchase.Print`;
          break;
        case IPermissionActionType.Authorize:
          permissionString = `Master.${masterName}.Purchase.Authorize`;
          break;
      }
      break;

    case SearchLedgerByGroupsTypes.BankOnly:
      switch (actionTypeAll) {
        case IPermissionActionType.Add:
          permissionString = `Master.${masterName}.Bank.Add`;
          break;
        case IPermissionActionType.Edit:
          permissionString = `Master.${masterName}.Bank.Edit`;
          break;
        case IPermissionActionType.Delete:
          permissionString = `Master.${masterName}.Bank.Delete`;
          break;
        case IPermissionActionType.Print:
          permissionString = `Master.${masterName}.Bank.Print`;
          break;
        case IPermissionActionType.Authorize:
          permissionString = `Master.${masterName}.Bank.Authorize`;
          break;
      }
      break;

    case SearchLedgerByGroupsTypes.CashOnly:
      switch (actionTypeAll) {
        case IPermissionActionType.Add:
          permissionString = `Master.${masterName}.Cash.Add`;
          break;
        case IPermissionActionType.Edit:
          permissionString = `Master.${masterName}.Cash.Edit`;
          break;
        case IPermissionActionType.Delete:
          permissionString = `Master.${masterName}.Cash.Delete`;
          break;
        case IPermissionActionType.Print:
          permissionString = `Master.${masterName}.Cash.Print`;
          break;
        case IPermissionActionType.Authorize:
          permissionString = `Master.${masterName}.Cash.Authorize`;
          break;
      }
      break;

    default:
      return false;
  }

  if (!permissionString) {
    return false;
  }

  return findUserOnlyOnePremission(
    permissionString,
    clientSpecificRole,
    clientId
  );
};
